import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonComponent } from '@shared/components/button';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';

@Component({
  selector: 'app-not-found',
  imports: [TitleComponent, ButtonComponent],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {
  title: Title = {
    size: {
      desktop: 'H3',
      mobile: 'H3',
    },
    level: 'SPAN',
    text: 'Toutes nos excuses...',
    align: {
      mobile: 'CENTER',
      desktop: 'CENTER',
    },
  };
  subTitle: Title = {
    size: {
      desktop: 'SPAN',
      mobile: 'SPAN',
      custom: {
        desktop: '1.4rem',
        mobile: '1.4rem',
      },
    },
    weight: 500,
    type: 'SLASH',
    level: 'H1',
    text: 'Page introuvable',
    color: 'ERROR',
    align: {
      mobile: 'CENTER',
      desktop: 'CENTER',
    },
  };
}
